import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=575ee546&scoped=true"
import script from "./GroupModal.vue?vue&type=script&lang=js"
export * from "./GroupModal.vue?vue&type=script&lang=js"
import style0 from "./GroupModal.vue?vue&type=style&index=0&id=575ee546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ee546",
  null
  
)

export default component.exports